import React from "react";
import type { CanvasDataSource } from "../../../types";
import type { RenderableElement } from "../CanvasRenderer";
import { CanvasKanbanRenderer } from "./CanvasKanbanRenderer";
import { CanvasRelatedRecordsRenderer } from "./CanvasRelatedRecordsRenderer";
import { CanvasHierarchyRenderer } from "./CanvasHierarchyRenderer";
import { CanvasCalendarRenderer } from "./CanvasCalendarRenderer";

interface Props {
  element: RenderableElement;
  dataSources: CanvasDataSource[];
  canvasId?: string | null;
}

/** Draws the data-bound widgets that need the canvas data sources: KANBAN, CALENDAR and RELATED_RECORDS. */
export function CanvasDataWidgetRenderer(props: Props) {
  if (props.element.type === "kanban")
    return <CanvasKanbanRenderer {...props} />;
  if (props.element.type === "calendar")
    return <CanvasCalendarRenderer {...props} />;
  if (props.element.type === "related_records")
    return <CanvasRelatedRecordsRenderer {...props} />;
  if (props.element.type === "hierarchy")
    return <CanvasHierarchyRenderer {...props} />;
  return null;
}

export default CanvasDataWidgetRenderer;
